module.exports = __webpack_public_path__ + "static/media/DealBaseLogo.27d70f89.svg";